module.exports = __webpack_public_path__ + "img/rank-3.da931364.svg";